import { render, staticRenderFns } from "./coupExchange.vue?vue&type=template&id=332e61de&"
import script from "./coupExchange.vue?vue&type=script&lang=js&"
export * from "./coupExchange.vue?vue&type=script&lang=js&"
import style0 from "./coupExchange.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports